import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 0 auto 60px;
  max-width: 1260px;
  width: 100%;
  padding: 0 30px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  @media (${laptopMediumMax}) {
    flex-direction: column-reverse;
  }
`;

export const RankingContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  &:last-child {
    padding-left: 30px;
    margin-left: 30px;
    border-left: 1px solid ${(props) => props.theme.keyline};
  }

  @media (${laptopMediumMax}) {
    &:last-child {
      padding-left: 0;
      margin-left: 0;
      border-left: none;
    }
  }
`;

export const RosetteContainer = styled.div`
  position: relative;
  margin: 30px auto;
`;

export const RosetteText = styled.p`
  width: 100%;
  text-align: center;
  position: absolute;
  top: 34px;
  font-weight: bold;
  font-size: 32px;
`;
